<template>
  <v-layout row justify-center>
    <v-dialog
      v-if="servicesList.length"
      fullscreen
      @keydown.esc="close"
      v-model="getEditCrewDialog"
    >
      <v-card>
        <v-card-title><h2>Select Crew for Tasking</h2></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h3>Select shifting crew</h3>
          <v-select
            :disabled="isPreplan"
            :items="filterPalBearers(servicesList)"
            v-model="selectedShiftingCrew"
            item-text="description"
            v-on:input="limiter"
            attach
            chips
            clearable
            multiple
            label="Select shifting crew"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
          <h3>Select sending crew</h3>
          <v-select
            :disabled="isPreplan"
            :items="filterPalBearers(servicesList, 1)"
            v-model="selectedSendingCrew"
            item-text="description"
            v-on:input="limiter"
            attach
            chips
            clearable
            multiple
            label="Select sending crew"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
          <h3>Select funeral crew</h3>
          <v-select
            :disabled="isPreplan"
            :items="filterPalBearers(servicesList, 2)"
            v-model="selectedFuneralCrew"
            item-text="description"
            v-on:input="limiter"
            attach
            chips
            clearable
            multiple
            label="Select funeral crew"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
          <h3>Select times</h3>
          <v-flex xs12>
            <v-flex xs12>
              <v-text-field
                label="Sending Time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="wakeSendingTime"
                type="time"
                :disabled="closed"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Leave Office Time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="leaveOfficeTime"
                type="time"
                :disabled="closed"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Leave Wake Time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="leaveWakeTime"
                type="time"
                :disabled="closed"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Cremation / Burial Time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="leaveFuneralTime"
                type="time"
                :disabled="closed"
              />
            </v-flex>
          </v-flex>

          <v-snackbar
            v-model="snackbar"
            color="#ff5353"
            multi-line
            top
            right
            :timeout=6000
          >
            You can select no more than three
            <v-btn
              dark
              flat
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray darken-1"
            flat
            @click="close"
          >Close</v-btn>
          <v-btn
            color="green darken-1"
            flat
            @click.native="submit"
          >{{ approvedBtnLabel }}Select & Notify</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import schedulesAPI from '@/api/resources/schedules'
  import AddLeadFormOld from '@/components/AddLeadFormOld'
  import { mapGetters } from 'vuex'

  export default {
    components: { AddLeadFormOld },
    computed: {
      ...mapGetters({
        getEditCrewDialog: 'getEditCrewDialog',
        getEditCrewCaseId: 'getEditCrewCaseId',
        servicesList: 'allServices',
        case: 'getCrewDialogCase',
        usersList: 'allUsersRaw'
      }),
      approved () {
        return this.getEditCrewCaseId && this.case && this.case.status === 'approved'
      },
      approvedBtnLabel () {
        if (!this.approved) return 'Approve Case, '
        return ''
      },
      isPreplan () {
        return this.case && this.case.is_preplan
      },
      timesSelected () {
        return this.wakeSendingTime && this.leaveOfficeTime && this.leaveWakeTime && this.leaveFuneralTime
      }
    },
    data () {
      return {
        selectedShiftingCrew: [],
        selectedSendingCrew: [],
        selectedFuneralCrew: [],
        snackbar: false,
        leadsUuid: null,
        caseData: null,
        wakeSendingTime: null,
        leaveOfficeTime: null,
        leaveWakeTime: null,
        leaveFuneralTime: null
      }
    },
    filters: {
      filterPalBearers (value, closing) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' &&
            this.usersList.filter(i => i.id === service.users_id).length > 0
          : false
        )
      }
    },
    watch: {
      getEditCrewCaseId (v) {
        if (this.getEditCrewCaseId) {
          casesAPI.getLead(this.getEditCrewCaseId).then(result => {
            this.leadsUuid = result[0].leads_id
            this.selectedShiftingCrew = result
              .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 0)
              .map(item => { return item.item_id })
            this.selectedSendingCrew = result
              .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 1)
              .map(item => { return item.item_id })
            this.selectedFuneralCrew = result
              .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 2)
              .map(item => { return item.item_id })
          }, () => {})
        }
      },
      caseData () {
        if (this.caseData.is_preplan) {
          this.isPreplan = true
          this.selectedShiftingCrew = []
          this.selectedSendingCrew = []
          this.selectedFuneralCrew = []
        }
      }
    },
    methods: {
      limiter (e) {
        if (e.length > 999) {
          this.snackbar = true
          e.pop()
        }
      },
      close () {
        this.$store.commit('switchCrewDialog')
      },
      async selectShiftingCrew () {
        try {
          const response = await schedulesAPI.updatePallbearers(this.leadsUuid, this.selectedShiftingCrew, 0)
          return response
        } catch (err) {
          return err
        }
      },
      async selectSendingCrew () {
        try {
          const response = await schedulesAPI.updatePallbearers(this.leadsUuid, this.selectedSendingCrew, 1)
          return response
        } catch (err) {
          return err
        }
      },
      async selectFuneralCrew () {
        try {
          const response = await schedulesAPI.updatePallbearers(this.leadsUuid, this.selectedFuneralCrew, 2)
          return response
        } catch (err) {
          return err
        }
      },
      async approveCase () {
        try {
          const response = await this.$store.dispatch('approveCase', this.getEditCrewCaseId)
          return response
        } catch (err) {
          return err
        }
      },
      async getCaseInvoices () {
        try {
          const response = await this.$store.dispatch('getCaseInvoices', this.getEditCrewCaseId)
          return response
        } catch (err) {
          return err
        }
      },
      async setTimes () {
        try {
          const data = {
            wake_sending_time: this.wakeSendingTime,
            leave_office_time: this.leaveOfficeTime,
            leave_wake_time: this.leaveWakeTime,
            leave_funeral_time: this.leaveFuneralTime
          }
          const response = await this.$axios.post(`${this.$store.getters.config.api_host}/api/cases/${this.getEditCrewCaseId}/times`, data)
          return response
        } catch (err) {
          return err
        }
      },
      async selectCrew (approve = false) {
        const updateShiftingCrew = await this.selectShiftingCrew()
        const updateSendingCrew = await this.selectSendingCrew()
        const updateFuneralCrew = await this.selectFuneralCrew()
        const setTimes = await this.setTimes()

        let approveCase = false
        let getInvoices = false

        if (approve) {
          approveCase = await this.approveCase()
          getInvoices = await this.getCaseInvoices()
        } else {
          approveCase = true
          getInvoices = true
        }

        if (updateShiftingCrew && updateSendingCrew && updateFuneralCrew && approveCase && getInvoices && setTimes) {
          setTimeout(() => {
            // this.$store.dispatch('loadAllCases')
            location.reload()
          }, 5000)
          this.$store.commit('switchCrewDialog')
        }
      },
      submit () {
        this.selectCrew(!this.approved)
      },
      filterPalBearers (value, closing) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' &&
            this.usersList.filter(i => i.id === service.users_id).length > 0 && this.usersList.find(i => i.id === service.users_id).roles.length > 0 && this.usersList.find(i => i.id === service.users_id).roles.filter(r => r.name === 'case-crew').length > 0
          : false
        )
      }
    },
    created () {
      if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers')
      if (this.$store.state.services.all.length === 0) this.$store.dispatch('getAllServices')
    }
  }
</script>



// WEBPACK FOOTER //
// CrewDialog.vue?565c1f31